<template>
  <div
    v-if="isPreview"
    class="alert alert-warning d-flex justify-content-between align-items-center"
    style="margin-bottom: 0;"
  >
    <span class="flex-grow-1">Preview mode</span>
    <button type="button" class="btn btn-link" @click="exitPreview">Go to live mode</button>
  </div>
</template>

<script>
export default {
  computed: {
    isPreview() {
      return this.$store.state.settings.isPreview
    },
  },
  methods: {
    exitPreview() {
      this.$store.commit('settings/setPreview', false)
      this.$router.replace({ name: 'device-selector' })
    },
  },
}
</script>
